import type {AxiosInstance} from 'axios';
import {ENDPOINTS} from 'general/constants';
import {logWithSentry} from 'sentry/sentry';

type QrCodeResponseType = {
    image: string;
};

type QrCodeParamsType = {
    text: string;
    refId: string;
    width?: number;
};

/**
 * Gets generated qr code from server
 * @param {AxiosInstance} instance - instance for correct request
 * @param {string} text - prefilled sms text
 * @param {string} refId - user unique id at the end of the text
 * @param {number} width - size of qr code
 * @returns {Promise<string | void>} - qr code image src or void if not found
 */
export const getQrCode = async (
    instance: AxiosInstance,
    {text, refId, width}: QrCodeParamsType,
): Promise<string | void> => {
    if (!refId) return;
    try {
        const response = await instance.post<QrCodeResponseType>(ENDPOINTS.GET_QRCODE, {
            text: `${text} (refID: ${refId})`,
            width,
        });

        return response?.data?.image;
    } catch (error) {
        logWithSentry(error as Error);
    }
};
